import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup'

const cErrorPassword = yup
  .object()
  .shape({
    email: yup.string().required('Email obligatoire'),
  })
  .required();
const ErrorPasswordProvider = ({children}) => {
    const methods = useForm({
        values:{
            email:'',      
        },
        defaultValues:{
            email:'',        
        },
        resolver:yupResolver(cErrorPassword)
    })
  return (
    <FormProvider {...methods}>{children}</FormProvider>
  )
}

export default ErrorPasswordProvider